export const translations = {
  pt: {
    nav: {
      home: 'INÍCIO',
      about: 'SOBRE',
      contact: 'CONTATOS',
      plans: 'PLANOS',
    },
    hero: {
      title1: 'SEU LAR',
      title2: 'NO CELULAR',
      subtitle: 'PLANEJE E GERENCIE SEU LAR E SUAS RECEPÇÕES COM FACILIDADE.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
    },
    features: {
      feature1: 'Uma ferramenta digital intuitiva que funciona como um co-host: te ajuda a organizar do começo ao fim.',
      feature2: 'Mais do que praticidade, oferecemos experiência: cada detalhe pensado para transformar encontros em memórias inesquecíveis.',
      feature3: 'Organize e acompanhe tudo o que você já tem em casa.',
      feature4: 'O Hostly gerencia seu acervo pessoal, evita compras duplicadas e ajuda você a visualizar combinações antes mesmo do evento.',
    },
    plans: {
      title: 'QUE TIPO DE ANFITRIÃ(O) É VOCÊ?',
      free: 'Free',
      basic: 'Basic',
      pro: 'Pro',
      freeForever: 'Grátis para sempre',
      perMonth: 'por mês',
      viewDetails: 'Ver Detalhes',
      subscribeNow: 'Assinar Agora',
      subscribePro: 'Assinar PRO',
    },
    video: {
      cta: 'Clique para assistir a apresentação',
    },
  },
  en: {
    nav: {
      home: 'HOME',
      about: 'ABOUT',
      contact: 'CONTACT',
      plans: 'PLANS',
    },
    hero: {
      title1: 'YOUR HOME',
      title2: 'ON YOUR PHONE',
      subtitle: 'PLAN AND MANAGE YOUR HOME AND RECEPTIONS WITH EASE.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
    },
    features: {
      feature1: 'An intuitive digital tool that works as a co-host: helps you organize from start to finish.',
      feature2: 'More than practicality, we offer experience: every detail designed to turn gatherings into unforgettable memories.',
      feature3: 'Organize and track everything you already have at home.',
      feature4: 'Hostly manages your personal collection, prevents duplicate purchases and helps you visualize combinations even before the event.',
    },
    plans: {
      title: 'WHAT KIND OF HOST ARE YOU?',
      free: 'Free',
      basic: 'Basic',
      pro: 'Pro',
      freeForever: 'Free forever',
      perMonth: 'per month',
      viewDetails: 'View Details',
      subscribeNow: 'Subscribe Now',
      subscribePro: 'Subscribe PRO',
    },
    video: {
      cta: 'Click to watch the presentation',
    },
  },
  es: {
    nav: {
      home: 'INICIO',
      about: 'ACERCA DE',
      contact: 'CONTACTO',
      plans: 'PLANES',
    },
    hero: {
      title1: 'TU HOGAR',
      title2: 'EN TU MÓVIL',
      subtitle: 'PLANIFICA Y GESTIONA TU HOGAR Y RECEPCIONES CON FACILIDAD.',
      appStore: 'App Store',
      googlePlay: 'Google Play',
    },
    features: {
      feature1: 'Una herramienta digital intuitiva que funciona como co-anfitrión: te ayuda a organizar de principio a fin.',
      feature2: 'Más que practicidad, ofrecemos experiencia: cada detalle pensado para transformar encuentros en memorias inolvidables.',
      feature3: 'Organiza y controla todo lo que ya tienes en casa.',
      feature4: 'Hostly gestiona tu colección personal, evita compras duplicadas y te ayuda a visualizar combinaciones incluso antes del evento.',
    },
    plans: {
      title: '¿QUÉ TIPO DE ANFITRIÓN ERES?',
      free: 'Free',
      basic: 'Basic',
      pro: 'Pro',
      freeForever: 'Gratis para siempre',
      perMonth: 'por mes',
      viewDetails: 'Ver Detalles',
      subscribeNow: 'Suscribirse Ahora',
      subscribePro: 'Suscribirse PRO',
    },
    video: {
      cta: 'Haz clic para ver la presentación',
    },
  },
};

export type Language = keyof typeof translations;
